export const NOW_FAQ_MODAL_ID = 'now-faq-modal'
export const NOW_FAQ_MODAL_CONTAINER_ID = 'now-faq-modal-container'
